import { AlertColor } from '@mui/material'
import { create } from 'zustand'

export type SnackbarData = {
  message: string
  severity: AlertColor
  anchorOrigin?: {
    vertical: 'top' | 'bottom'
    horizontal: 'left' | 'center' | 'right'
  }
}

type SnackbarStore = {
  snackbarData: SnackbarData | null
  open: boolean
  showSnackbar: (data: SnackbarData) => void
  closeSnackbar: () => void
}

export const useSnackbar = create<SnackbarStore>(set => ({
  snackbarData: null,
  open: false,
  showSnackbar: data => set({ snackbarData: data, open: true }),
  closeSnackbar: () => set({ snackbarData: null, open: false })
}))
